import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "charcter-shoppingcart" }
const _hoisted_2 = { class: "me-2 py-0 px-2 charcter-message speech-bubble speech-bubble-right speech-bubble-bg-white speech-bubble-border-accent2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "申込リスト", -1)
const _hoisted_4 = {
  key: 0,
  class: "d-block"
}
const _hoisted_5 = { class: "me-1 fs-4" }
const _hoisted_6 = {
  key: 1,
  class: "d-block badge bg-danger mb-1 fs-8 fw-bold"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "charcter-character" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-caret-left-fill",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z" })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "px-4 py-2 py-lg-4 flex-grow-1 overflow-scroll",
  style: {"max-height":"100vh"}
}
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "mt-0 mt-lg-4 mb-4 fs-4 fw-bold" }
const _hoisted_14 = {
  key: 0,
  class: "d-block badge bg-danger ml-2 mb-1 fs-6 text-wrap"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block" }, "申し込みは完了していません。", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block" }, "参加申込が必要です！", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "my-3 text-center fs-6 fw-bold" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "text-center mb-3 shoppingcart-submit-btn" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "fs-6 table table-striped table-bordered align-top webtan-shoppingcart-table" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "日時"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "時間"),
    /*#__PURE__*/_createElementVNode("th", null, "番号"),
    /*#__PURE__*/_createElementVNode("th", null, "タイトル"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_28 = { class: "cart-table-col-date" }
const _hoisted_29 = { class: "cart-table-col-reg-type" }
const _hoisted_30 = { class: "cart-table-col-time" }
const _hoisted_31 = { class: "cart-table-col-id" }
const _hoisted_32 = { class: "cart-table-col-title col-6 text-break" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 0,
  class: "ms-2 small fw-normal"
}
const _hoisted_37 = { class: "cart-table-col-action text-center" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "text-center shoppingcart-submit-btn" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "mt-3 text-center shoppingcart-close-btn" }
const _hoisted_43 = {
  key: 0,
  class: "my-5"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 mb-4 fs-4 fw-bold" }, "視聴リスト（申込済）", -1)
const _hoisted_46 = { key: 0 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "my-5 text-center fs-6 fw-bold" }, "視聴リスト（申込済み）は空です", -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "fs-6 table table-striped table-bordered align-top webtan-shoppingcart-table" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "日時"),
    /*#__PURE__*/_createElementVNode("th"),
    /*#__PURE__*/_createElementVNode("th", null, "時間"),
    /*#__PURE__*/_createElementVNode("th", null, "番号"),
    /*#__PURE__*/_createElementVNode("th", null, "タイトル"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_52 = { class: "cart-table-col-date" }
const _hoisted_53 = { class: "cart-table-col-reg-type" }
const _hoisted_54 = { class: "cart-table-col-time" }
const _hoisted_55 = { class: "cart-table-col-id" }
const _hoisted_56 = { class: "cart-table-col-title col-6 text-break" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = ["innerHTML"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = {
  key: 2,
  class: "ms-2 small fw-normal"
}
const _hoisted_61 = { class: "cart-table-col-action text-center" }
const _hoisted_62 = { class: "d-inline-flex" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-start icon-me-2 icon-zoom" }, "視聴", -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = ["onClick"]

import { onMounted } from 'vue';

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ShoppingCart',
  props: {
    sessions: { type: Object },
    cart: { type: Object },
    entryList: { type: Object },
    shoppingCart: { type: Boolean },
    login: { type: Boolean },
    webinarMainLabel: { type: String },
    webinarSubLabel: { type: String },
    findSession: {type: Function}
  },
  emits: ['removeItem', 'cancelItem', 'toggleShoppingCart', 'submitForm', 'openExternalLink'],
  setup(__props, { emit: __emit }) {

  const props = __props
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const emits = __emit;

  const removeItem = (id: string) => {
    emits('removeItem', id);
  }

  const cancelItem = (session: object) => {
    emits('cancelItem', session);
  }

  const toggleShoppingCart = () => {
    emits('toggleShoppingCart');
  }
  
  const onClickStopPropagation = (evt) => {
  	// @click.stopclick="void"
  	// @click.stopclick="onClickStopPropagation"
  	// だとダメだったので、ふつうのハンドラ内でstopPropagation();
  	// Vue 3では.stopか。。。
  	evt.stopPropagation();
  }

  const submitForm = () => {
    emits('submitForm');
  }

  const openExternalLink = (url: string) => {
    emits('openExternalLink', url);
  }

  const findSession = (cartValue: object[]) => {
    return emits('findSession', cartValue);
  }

  onMounted (() => {
  
  	// ショッピングカートの有無でCSS切り替えできるように
  	// でもApp rootと右マージン指定してる要素が違ってて
  	// サイトによって差異がでるとアレなので、bodyにクラス名つける
  	// たぶんVueの作法じゃないけど気にしない方向で
    const bodyElem = document.getElementsByTagName('body')[0];
    if (bodyElem) {
    	bodyElem.classList.add('webtan-event-has-shoppingcart');
    }
    // ヘッダーとかadmin_menuとかでショッピングカートの上部が隠れないように
    // #appのviewport上端からの距離をCSS変数に入れる
    if (document.querySelector('#header')) {
    	// 最初IntersectionObserverでやってたけど最期の処理が微妙だったので
    	// 結局scrollイベント＋throttleにした
    	// Drupal.throttleあるけどテストサイトとかあるので独自に定義
    	const throttleTimeoutIds = {};
			const throttle = (...args) => {
				const name = args.shift();
				const func = args.shift();
				const interval = args.shift() || 200;
				if (
					'undefined' != typeof(throttleTimeoutIds[name]) &&
					false != throttleTimeoutIds[name]
				) {
					clearTimeout(throttleTimeoutIds[name]);
					throttleTimeoutIds[name] = false;
				}
				throttleTimeoutIds[name] = setTimeout(
					function(){func.apply(null, args);},
					interval
				);
			};
			// これが処理本体
			const scrollEvent = () => {
      	const rect = document.querySelector('#app')?.getBoundingClientRect();
      	if (rect) {
					const 
						headerHeightFixed = parseInt(
							(
								getComputedStyle(
									document.documentElement
								).getPropertyValue('--header-height-fixed')
								|| '0px'
							).replace(/px$/, '')
						),
						drupalDisplaceOffsetTop = parseInt(
							(
								getComputedStyle(
									document.documentElement
								).getPropertyValue('--drupal-displace-offset-top')
								|| '0px'
							).replace(/px$/, '')
						),
						// cssで3つあわせて計算してるので
						appTopOffsetGap = Math.max(
							0,
							rect.top - headerHeightFixed - drupalDisplaceOffsetTop
						) + 'px',
						appTopOffsetGapKey = '--app-top-offset-gap';
					// documentElement.style更新するのは変わったときだけ
					if (document.documentElement.style.getPropertyValue(appTopOffsetGapKey) != appTopOffsetGap) {
		        document.documentElement.style.setProperty(
		        	appTopOffsetGapKey,
		        	appTopOffsetGap
		        );
		      }
	      }
      };
      // スクロールイベント
      window.addEventListener('scroll', evt => {
      	throttle('shoppingcart', scrollEvent, 50);
    	});
    	scrollEvent();
    }

  });



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "position-fixed top-0 end-0 h-100 d-flex shoppingcart-wrapper",
    style: {"z-index":"999"},
    onClick: _withModifiers(onClickStopPropagation, ["stop","prevent"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["appearance-none charcter-wrapper", __props.shoppingCart ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleShoppingCart()))
      }, [
        _createElementVNode("span", _hoisted_2, [
          _hoisted_3,
          (__props.cart && __props.entryList)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(__props.cart.length + __props.entryList.length), 1),
                _createTextVNode("件")
              ]))
            : _createCommentVNode("", true),
          (__props.cart && __props.cart.length != 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                _createTextVNode("参加申込が"),
                _hoisted_7,
                _createTextVNode("必要です！")
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_8
      ], 2)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([__props.shoppingCart ? 'active' : 'opacity-75', "shoppingcart h-100 d-flex bg-light"])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass([__props.shoppingCart ? 'rotate-180' : '', "p-1 appearance-none text-white bg-accent2 flex-shrink-1"]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleShoppingCart()))
      }, _hoisted_10, 2),
      (__props.shoppingCart)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                class: "p-0 p-lg-3 position-absolute top-0 end-0 appearance-none fs-2 text-muted",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleShoppingCart())),
                style: {"z-index":"2"}
              }, "×")
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode("申込リスト"),
                (__props.cart && __props.cart.length != 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              (__props.cart && __props.cart.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createTextVNode("申込リスト"),
                      (__props.login)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "（未申込）"))
                        : _createCommentVNode("", true),
                      _createTextVNode("は空です")
                    ])
                  ]))
                : _createCommentVNode("", true),
              (__props.cart && __props.cart.length > 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "px-3 px-lg-5 btn btn-lg btn-accent2 fw-bold",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (submitForm()))
                      }, [
                        (!__props.login)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_23, "参加申込する（無料）"))
                          : _createCommentVNode("", true),
                        (__props.login)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "追加申込する（無料）"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (__props.cart && __props.cart.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("table", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.findSession(__props.cart), (session, i) => {
                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                            _createElementVNode("td", _hoisted_28, _toDisplayString(session.date), 1),
                            _createElementVNode("td", _hoisted_29, _toDisplayString(session.reg_type == 'alt' ? session.shoppingCartLabelAlt : session.shoppingCartLabel), 1),
                            _createElementVNode("td", _hoisted_30, _toDisplayString(session.timeStart) + "〜" + _toDisplayString(session.timeEnd), 1),
                            _createElementVNode("td", _hoisted_31, _toDisplayString(session.id), 1),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("div", {
                                class: "fw-bold",
                                innerHTML: session.title
                              }, null, 8, _hoisted_33),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.speakers, (speaker, o) => {
                                return (_openBlock(), _createElementBlock("div", { key: o }, [
                                  (speaker.company)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "me-2",
                                        innerHTML: speaker.company
                                      }, null, 8, _hoisted_34))
                                    : _createCommentVNode("", true),
                                  (speaker.name)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, [
                                        _createTextVNode(_toDisplayString(speaker.name) + " ", 1),
                                        (!speaker.spk_non_dear_flg)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, "氏"))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("td", _hoisted_37, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "text-nowrap btn btn-secondary",
                                onClick: ($event: any) => (removeItem(session.layout_id))
                              }, "削除", 8, _hoisted_38)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-3 px-lg-5 btn btn-lg btn-accent2 fw-bold",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm()))
                }, [
                  (!__props.login)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_40, "参加申込する（無料）"))
                    : _createCommentVNode("", true),
                  (__props.login)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, "追加申込する（無料）"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("button", {
                  type: "button",
                  class: "px-3 px-lg-5 btn btn-outline-secondary fw-bold",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleShoppingCart()))
                }, "もどる")
              ])
            ]),
            (__props.login)
              ? (_openBlock(), _createElementBlock("hr", _hoisted_43))
              : _createCommentVNode("", true),
            (__props.login)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  (__props.entryList && __props.entryList.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_48))
                    : _createCommentVNode("", true),
                  (__props.entryList && __props.entryList.length != 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createElementVNode("table", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.findSession(__props.entryList), (session, i) => {
                              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                _createElementVNode("td", _hoisted_52, _toDisplayString(session.date), 1),
                                _createElementVNode("td", _hoisted_53, _toDisplayString(session.reg_type == 'alt' ? session.shoppingCartLabelAlt : session.shoppingCartLabel), 1),
                                _createElementVNode("td", _hoisted_54, _toDisplayString(session.timeStart) + "〜" + _toDisplayString(session.timeEnd), 1),
                                _createElementVNode("td", _hoisted_55, _toDisplayString(session.id), 1),
                                _createElementVNode("td", _hoisted_56, [
                                  _createElementVNode("div", {
                                    class: "fw-bold",
                                    innerHTML: session.title
                                  }, null, 8, _hoisted_57),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(session.speakers, (speaker, o) => {
                                    return (_openBlock(), _createElementBlock("div", { key: o }, [
                                      (speaker.company)
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 0,
                                            class: "me-2",
                                            innerHTML: speaker.company
                                          }, null, 8, _hoisted_58))
                                        : _createCommentVNode("", true),
                                      (speaker.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(speaker.name), 1))
                                        : _createCommentVNode("", true),
                                      (speaker.name)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, "氏"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("td", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    (session.watch && session.webinarMainURL && __props.webinarMainLabel)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "text-nowrap btn btn-accent",
                                          onClick: _withModifiers(($event: any) => (openExternalLink(session.webinarMainURL)), ["stop","prevent"])
                                        }, _hoisted_65, 8, _hoisted_63))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "ms-3 text-nowrap btn btn-secondary",
                                      onClick: ($event: any) => (cancelItem(session))
                                    }, "削除", 8, _hoisted_66)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})